<template>
  <section id="materials" class="py4 px3">
    <h1 class="m0 mb3 center" :class="{'mb3': !standalone, 'mb4': standalone}" v-html="content.title"></h1>
    <div class="flex flex-wrap justify-center">
      <article class="flex flex-column justify-between m2" v-for="item in articles" :key="item.id">
        <header>
          <router-link class :to="{name: 'Article', params: {lang: item.language.code, slug: item.slug, oid: item.id}}"
                       @click="scrollTo($event, 'app')">
            <div :id="'cover_' + item.id" class="cover" v-if="item.cover"
                 :style="'background-image: url(' + getContentAPIBase() + item.cover.url + '); background-size: cover; background-position: center center;'"></div>
          </router-link>
          <div class="p2">
            <h2 class="h3 m0">
              <router-link class="black-blue-link" :id="'title_link_' + item.id"
                           :to="{name: 'Article', params: {lang: item.language.code, slug: item.slug, oid: item.id}}"
                           v-html="item.title" @click="scrollTo($event, 'app')"></router-link>
            </h2>
          </div>
        </header>
        <footer class="p2">
          <div class="dark-grey h6 flex items-center">
            <span>{{ formatDate(item.createdAt) }}</span>
          </div>
        </footer>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  props: ['lang', 'standalone'],

  created () {
    // loadContent is a global helper method
    this.content = this.loadContent(this.lang, 'articles-list')
    this.updateArticles(this.lang)
  },

  watch: {
    '$route' (to, from) {
      if (from.params.lang !== to.params.lang) {
        this.content = this.loadContent(this.lang, 'articles-list')
        this.updateArticles(this.lang)
      }
    }
  },

  data () {
    return {
      content: {},
      articles: [],
      tags: []
    }
  },

  methods: {
    updateArticles (lang) {
      // TODO: is it possible to fetch only certain fields: title, cover, date?
      fetch(this.getContentAPIBase() + '/contents?category.slug=articles&public=true&language.code=' + lang).then((response) => {
        return response.json()
      }).then((data) => {
        this.articles = data
        this.sortByDate(this.articles)
      }).catch((err) => {
        console.error('fetch error', err)
      })
    },

    sortByDate (events) {
      events.sort(function (a, b) {
        a = new Date(a.createdAt)
        b = new Date(b.createdAt)
        return a > b ? -1 : a < b ? 1 : 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/colors";

$article-height: 25em;

article {
  height: $article-height;
  background: rgb(242, 246, 247);
  width: 20em;
  overflow: hidden;
  position: relative;
}

.cover {
  height: $article-height / 2;
  width: 100%;
  background: lighten($dark-grey, 30%);
  transition: all 0.2s ease-out;
}

.tag-list a {
  color: $dark-grey;

  &:hover,
  &:focus {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// ArticlesList.vue?ab59cfae